import DestinationIndex from "@/views/directory/destination/DestinationIndex.vue";

const destination = [
    {
        path: '/destinations',
        name: 'destination',
        component: DestinationIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default destination;